<template>
  <v-form ref="form" :readonly="readonly">
    <v-row>
      <v-col cols="12" md="12">
        <v-autocomplete 
          :search-input.sync="search" 
          @change="itemChange"
          v-model="selected_client" 
          v-if="!readonly" 
          label="Digite o nome do cliente para adicionar" 
          prepend-icon="mdi-account-box" 
          :items="clients" 
          :item-text="formatClientDisplayName" 
          return-object 
          :filter="filterClients" 
          :loading="loading.clients"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="pb-1">
                <span v-if="item.attributes.id"> Nome/Rz social:</span> 
                <b> {{ formatClientDisplayName(item) }} </b> 
              </v-list-item-title>
              <v-list-item-subtitle class="mb-1" v-if="item.attributes.fantasyName && item.attributes.fantasyName != item.attributes.name">
                Nome fantasia: <b> {{item.attributes.fantasyName}} </b>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="d-flex justify-space-between" v-if="item.id">
                <div>ID: <b>{{ item.id }} </b> </div>
                <div>Cidade: <b>{{ item.attributes.city }}</b></div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-alert type="info" class="ma-1">Digite o nome do cliente para adicionar</v-alert>
          </template>
        </v-autocomplete>
        
        <v-data-table 
          :loading="loading.clients" 
          :items="selected_clients" 
          :headers="computed_headers" 
          :search="search_data_table"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search_data_table"
              label="Buscar"
              class="mx-4"
              prepend-inner-icon="mdi-magnify"
              :readonly="false"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{item}" v-if="!readonly">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="removeClient(item.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Remover cliente do grupo</span>
            </v-tooltip>    
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'
import clientDisplay from '@/mixins/clientDisplay'

export default {
  name: 'EconomicGroupSelectClients',
  mixins: [validations, clientDisplay],
  props: {
    economic_group: {
      required: true,
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    set_clients: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeout_function: null,
      headers: [
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'Cidade', value: 'attributes.city', align: 'center' },
      ],
      search: '',
      search_data_table: '',
      clients: [],
      selected_clients: [],
      selected_client: null,
      loading: {
        clients: false
      }
    }
  },
  computed: {
    computed_headers() {
      if (this.readonly) {
        return this.headers
      } else {
        return [
          ...this.headers,
          { text: 'Ações', value: 'actions', align: 'center' },
        ]
      }
    },
  },
  methods: {
    getData() {
      this.setClients()
    },
    setClients() {
      this.selected_clients = []
      if (this.economic_group?.client_ids?.length > 0) {
        this.loading.clients = true
        let params = { 
          economic_group_id: this.economic_group.id
        }
        Api.Client.index(params).then((res) => {
          this.selected_clients = [...res.data?.data]
        }).catch(er => {
          console.error(er)
        }).finally(() => {
          this.loading.clients = false
        })
      }
    },
    itemChange(item) {
      if (item?.id) {
        let clientId = Number(item.id)
        let alreadySelected = this.economic_group.client_ids.some(id => Number(id) === clientId)
        if (!alreadySelected) {
          this.economic_group.client_ids.push(clientId)
          this.selected_clients = [item].concat(this.selected_clients)
        }
      }
      this.$nextTick(() => {
        this.search = '';
        this.selected_client = null;
        this.clients = []
      });
    },
    handleChangeSearch() {
      clearTimeout(this.timeout_function)
      if (this.search && this.search?.length >= 3) {
        this.timeout_function = setTimeout(() => {
          this.getClients()
        }, 500)
      }
    },
    getClients() {
      let params = { query: this.search }

      this.loading.clients = true
      Api.Client.search(params).then(res => {
        let allClients = res.data?.data || []
        this.clients = allClients.filter(client => {
          let clientId = Number(client.id)
          return !this.economic_group.client_ids.some(id => Number(id) === clientId)
        })
      }).finally(() => {
        this.loading.clients = false
      })
    },
    validate() {
      return this.$refs.form.validate()
    },
    removeClient(id) {
      let index_of_id = this.economic_group.client_ids.indexOf(String(id))
      let index_of_selected = this.selected_clients.findIndex((el) => {
        return el.id == String(id)
      })

      if (index_of_id == -1) {
        index_of_id = this.economic_group.client_ids.indexOf(Number(id))
      }
      if (index_of_selected == -1) {
        index_of_selected = this.selected_clients.findIndex((el) => {
          return el.id == Number(id)
        })
      }
      this.economic_group.client_ids.splice(index_of_id, 1)
      this.selected_clients.splice(index_of_selected, 1)
    },
    filterClients(item, queryText, itemText) {
      const name = item?.attributes.name ? item?.attributes.name.toLowerCase() : ''
      const corporate_name = item?.attributes.corporateName ? item?.attributes.corporateName.toLowerCase() : ''
      const fantasyName = item?.attributes.fantasyName ? item?.attributes.fantasyName.toLowerCase() : ''
      const city = item?.attributes.city ? item?.attributes.city.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || corporate_name.indexOf(searchText) > -1 || fantasyName.indexOf(searchText) > -1 || city.indexOf(searchText) > -1 || id.indexOf(searchText) > -1
    },
  },
  watch: {
    search() {
      this.handleChangeSearch()
    },
    set_clients(nv) {
      if (nv) {
        this.setClients()
      }
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

